// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"4aec9199","453":"fc78063f","866":"d79db3d5"}[chunkId] + ".chunk.js";
};